import { render, staticRenderFns } from "./WebhookConfig.vue?vue&type=template&id=28c3dc35&lang=pug&"
import script from "./WebhookConfig.vue?vue&type=script&lang=js&"
export * from "./WebhookConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports